import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const services = [
  {
    icon: '⬡',
    title: 'PC Health Monitoring',
    desc: 'Continuous real-time monitoring of every endpoint in your organization — before problems become downtime.',
  },
  {
    icon: '◧',
    title: 'Workstation Setup',
    desc: 'We configure, deploy, and document every machine to your standards. Day-one ready, every time.',
  },
  {
    icon: '↗',
    title: 'Remote Support',
    desc: 'Fast, secure remote assistance for your team. Most issues resolved in under 30 minutes.',
  },
  {
    icon: '⬛',
    title: 'Cybersecurity',
    desc: 'Threat detection, endpoint protection, and security consulting tailored for regulated industries.',
  },
  {
    icon: '◉',
    title: 'IT Consulting',
    desc: 'Strategic guidance on infrastructure, compliance, and technology roadmaps — from someone who speaks your language.',
  },
  {
    icon: '⬜',
    title: 'Compliance & Policy',
    desc: 'Policies, documentation, and audit-ready configurations for law firms, accountants, and regulated businesses.',
  },
];

const industries = [
  { label: 'Law Firms', detail: 'Data privacy, client confidentiality, and zero-downtime operations.' },
  { label: 'Accounting Firms', detail: 'CRA compliance, secure file handling, and endpoint control.' },
  { label: 'School Boards', detail: 'Scalable device management for educational environments.' },
];

const stats = [
  { value: '<30m', label: 'Avg. response time' },
  { value: '99.9%', label: 'Uptime target' },
  { value: '24/7', label: 'Monitoring coverage' },
  { value: '100%', label: 'Canadian-based support' },
];

export default function Home() {
  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero-grid-bg" aria-hidden="true" />
        <div className="container hero-inner">
          <span className="tag">Bluepeak IT Solutions</span>
          <h1 className="hero-headline">
            IT infrastructure<br />
            <span className="hero-accent">built for trust.</span>
          </h1>
          <p className="hero-sub">
            Managed IT, cybersecurity, and consulting for law firms, accounting practices,
            and professional services organizations that can't afford to go down.
          </p>
          <div className="hero-actions">
            <Link to="/contact" className="btn-primary">Get a Free Consultation →</Link>
            <Link to="/solutions" className="btn-outline">View Solutions</Link>
          </div>
          <div className="hero-stats">
            {stats.map(s => (
              <div key={s.label} className="stat">
                <span className="stat-value">{s.value}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="hero-scroll-hint">
          <span className="scroll-line" />
        </div>
      </section>

      {/* Services Overview */}
      <section className="section services-section">
        <div className="container">
          <span className="tag">What we do</span>
          <h2 className="section-title">End-to-end IT, handled.</h2>
          <p className="section-sub">
            From the moment a new hire gets their machine to the day a threat is detected
            and neutralized — Bluepeak is the team behind the curtain.
          </p>
          <div className="services-grid">
            {services.map(s => (
              <div key={s.title} className="service-card">
                <span className="service-icon">{s.icon}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="services-cta">
            <Link to="/solutions" className="btn-outline">Explore all solutions →</Link>
          </div>
        </div>
      </section>

      {/* Industries */}
      <section className="section-sm industries-section">
        <div className="container">
          <span className="tag">Who we serve</span>
          <h2 className="section-title">Built for professional services.</h2>
          <div className="industries-list">
            {industries.map((ind, i) => (
              <div key={ind.label} className="industry-row">
                <span className="industry-num">0{i + 1}</span>
                <span className="industry-label">{ind.label}</span>
                <span className="industry-detail">{ind.detail}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="cta-strip">
        <div className="container cta-strip-inner">
          <div>
            <h2>Ready to secure your operations?</h2>
            <p>No pressure. Just a conversation about where your IT stands today.</p>
          </div>
          <Link to="/contact" className="btn-primary">Talk to Bluepeak →</Link>
        </div>
      </section>
    </div>
  );
}
